const PRECISION = 0.00001; // numbers less than this is considered as 0

export default function isNumberEqual(a: number, b: number, precision: number = PRECISION): boolean {
  return Math.abs((a - b)) < precision;
};
